import { render, staticRenderFns } from "./FomrSubmitted.vue?vue&type=template&id=4bfdc339&"
import script from "./FomrSubmitted.vue?vue&type=script&lang=js&"
export * from "./FomrSubmitted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports